const servicesPageData = {
    page_heading: "Services",
    breadcrumb: [
        { name: "Home", className: "breadcrumb-item", link: "/" },
        { name: "Page", className: "breadcrumb-item", link: "#" },
        { name: "Services", className: "breadcrumb-item active" }
    ],
    features_list: [
        {
            id: 1,
            icon: 'uil uil-fire h2 text-primary',
            title: 'Efficient Heating Solutions',
            description:
                'Discover innovative heating designs that ensure optimal warmth and comfort in any environment.',
        },
        {
            id: 2,
            icon: 'uil uil-wind h2 text-primary',
            title: 'Ventilation Management',
            description:
                'Effective ventilation strategies for maintaining fresh and clean air quality throughout your space.',
        },
        {
            id: 3,
            icon: 'uil uil-search h2 text-primary',
            title: 'Strategic HVAC Planning',
            description:
                'Strategize and research the best HVAC solutions tailored to your specific needs and requirements.',
        },
        {
            id: 4,
            icon: 'uil uil-cloud-sun h2 text-primary',
            title: 'Climate Control',
            description:
                'Immerse yourself in comfort with our advanced climate control solutions. Experience unparalleled cooling performance designed to adapt seamlessly to various weather conditions, ensuring optimal comfort year-round.',
        },
        {
            id: 5,
            icon: 'uil uil-calendar-alt h2 text-primary',
            title: 'Daily Performance Reports',
            description:
                'Receive comprehensive reports on the daily performance of your HVAC systems for informed decision-making.',
        },
        {
            id: 6,
            icon: 'uil uil-globe h2 text-primary',
            title: 'Global Timezone Support',
            description:
                'Access real-time HVAC monitoring and control, ensuring comfort across different time zones.',
        },
        {
            id: 7,
            icon: 'uil uil-wrench h2 text-primary',
            title: 'Equipment Maintenance',
            description:
                'Ensure the longevity and optimal performance of your HVAC equipment with our regular and proactive maintenance services.',
        },
        {
            id: 8,
            icon: 'uil uil-lightbulb h2 text-primary',
            title: 'Energy-Efficient Solutions',
            description:
                'Implement energy-efficient HVAC solutions to reduce your carbon footprint and lower utility costs without compromising performance.',
        },
        {
            id: 9,
            icon: 'uil uil-water h2 text-primary',
            title: 'Humidity Control',
            description:
                'Maintain ideal indoor humidity levels with our advanced HVAC systems, enhancing comfort and preventing issues like mold and mildew.',
        },
        {
            id: 10,
            icon: 'uil uil-shield-check h2 text-primary',
            title: 'Air Quality Assurance',
            description:
                'Ensure excellent indoor air quality with our HVAC systems, equipped with advanced filtration and purification technologies.',
        },
        {
            id: 11,
            icon: 'uil uil-chart-line h2 text-primary',
            title: 'Performance Analytics',
            description:
                'Access detailed analytics and performance data for your HVAC systems, allowing you to make data-driven decisions for optimal efficiency.',
        },
        {
            id: 12,
            icon: 'uil uil-user-md h2 text-primary',
            title: 'Professional Consultations',
            description:
                'Benefit from expert HVAC consultations to tailor solutions specifically to your space, addressing unique challenges and maximizing efficiency.',
        },
    ],
    our_work: {
        work_list: [
            {
                imgUrl: '1.jpg',
                title: 'Shifting Perspective',
                subtitle: 'Studio',
                author: 'Calvin Carlo',
                date: '13th August, 2019',
            },
            {
                imgUrl: '2.jpg',
                title: 'Colors Magazine',
                subtitle: 'Web Design',
                author: 'Calvin Carlo',
                date: '13th August, 2019',
            },
            {
                imgUrl: '3.jpg',
                title: 'Spa Cosmetics',
                subtitle: 'Developing',
                author: 'Calvin Carlo',
                date: '13th August, 2019',
            },
            {
                imgUrl: '4.jpg',
                title: 'Riser Coffee',
                subtitle: 'Branding',
                author: 'Calvin Carlo',
                date: '13th August, 2019',
            },
        ],
    },
    endSection: {
        title: "Upgrade Your Comfort with Subul Contracting",
        description: [
            { type: "text", content: "Discover HVAC excellence with" },
            { type: "highlighted", content: "Subul Contracting." },
            { type: "text", content: "Elevate your space's comfort, efficiency, and air quality. Let's transform your indoors!" },
        ],
        buttonText: "Get in Touch"
    },
    seeMore: "See More",
    hideMore: "Hide More",
};

export { servicesPageData }